module.exports = __webpack_public_path__ + "img/imageA.faa0c7e0.png";